<div class="m-4">
  <div class="d-flex justify-content-center align-items-center flex-column">
    <img
      fetchpriority="high"
      width="56"
      height="56"
      src="images/success-tick.svg"
      alt="Success"
    />
    <div class="text-center">
      <h1 class="text-2xl fw-600 mb-2">Request Sent</h1>
      <p class="text-sm">
        Your request for creating an organization has been sent to the AIKosh
        Platform Admin.
      </p>
    </div>
    <button
      class="form-button btn-secondary w-100"
      type="submit"
      (click)="redirectToHome()"
    >
      Back to Homepage
    </button>
  </div>
</div>
